module.exports = __webpack_public_path__ + "img/digitalIdentity11.debf7abc.png";